import { Component, ViewChild } from '@angular/core';
import { App, NavController, NavParams, ViewController, ModalController, Slides } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { SignupPage } from '../signup/signup';
import { TabsPage } from '../employee/tabs/tabs';
import { DashboardPage } from '../employer/dashboard/dashboard';
import { Storage } from '@ionic/storage'

import { AuthProvider } from '../../providers/auth/auth'
import { JwtHelperService } from '@auth0/angular-jwt';
import { CompanyCreatePage } from '../createcompany/createcompany';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { TranslateService } from '@ngx-translate/core';
import {CreateLunch} from "../employee/lunchroulette/create-lunch/create-lunch";
import {CreateVisio} from "../employee/lunchroulette/create-visio/create-visio";
import {HomePage} from "../employee/home/home";
import {LunchroulettePage} from "../employee/lunchroulette/lunchroulette";
import {ProfilePage} from "../employee/profile/profile";
import { TabsPageRh } from '../employee/tabsRh/tabsRh';


@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {
  changeBg: boolean = false;
  local = 'fr';
  @ViewChild('slides') slides: Slides;

  constructor(public app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private storage: Storage,
    public authProvider: AuthProvider,
    private helper: JwtHelperService,
    private iab: InAppBrowser,
    public translate: TranslateService,
  ) {
    this.storage.get('LOCAL').then(local => {
      if(local){
        this.local = local;
      }
    })
  }

  ngOnInit(){

  }

  ionViewDidLoad() {
    this.storage.get("access_token").then((res) => {
      if (res) {
        this.proceedLogin(res)
      }
    })

    this.storage.get('LOCAL').then(local => {
      if(local){
        this.seti18n(local)
      }
    })

  }

  proceedLogin(token) { // Loading front according to if employee or employer

    this.authProvider.user = this.helper.decodeToken(token);

    if(this.authProvider.user.options.settings_social_network_enabled == false){
      this.app.getRootNav().setRoot(TabsPageRh)
        .then(() => {

        })
     }
     else{
      this.app.getRootNav().setRoot(TabsPage)
        .then(() => {})
     }

  }

  goToLogin() {
    let modal = this.modalCtrl.create(LoginPage, {}, { cssClass: 'modal-gradient' });
    modal.present().then(() => {});
  }

  goToSignup() {
    let modal = this.modalCtrl.create(SignupPage, {}, { cssClass: 'modal-gradient' });
    modal.present().then(() => {});
  }

  goToCreateCompany() {
    const browser = this.iab.create('https://panel.teambuildr.fr/account/signup', '_system', 'location=yes')
  }

  slideChanged() {
    this.changeBg = this.slides.getActiveIndex() > 0;
  }

  seti18n(local){
    this.translate.use(local);
    this.storage.set('LOCAL', local).then(() => {
    })
  }

  languageChanged(e){
    this.seti18n(e)
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts